<div *ngIf="!isWebAppLink" class="lm-card-view" [ngClass]="{'smallMenuDashboard': smallMenuInDashboard, 'inline': isParagraph }">
  <div class="lm-card-image" [ngClass]="{'smallMenuDashboardImage': smallMenuInDashboard }">
    <img *ngIf="hasImage" [ngClass]="{'smallImg': !isLargeScale, 'noFloat' : isParagraph }" src="{{imageUrl}}" alt="" (click)="onClickEvent($event)"/>
    <!-- decorative image, alt can be left blank since there's a title span below -->
  </div>
  <div class="lm-card-content" [ngClass]="{'titlePadding': isParagraph }">
    <div class="lm-card-title" [ngClass]="{'adjustTitle': !isLargeScale }" soho-tooltip title="{{title | formatMessageRule:true:title:model:specFields}}">
      <a soho-hyperlink
         [attr.tabindex]="isInAccessibilityMode ? 0 : null"
         (fieldEvent)="onFieldEvent($event)"
         (keydown.enter)="onClickEvent($event)"
         (click)="onClickEvent($event)">
        <span [ngClass]="{'paraTitle': isParagraph }">{{title | formatMessageRule:true:title:model:specFields}}</span>
      </a>
    </div>
    <div *ngIf="!isParagraph" class="lm-card-flex">
      <div class="lm-column">
        <p *ngIf="isLargeScale" soho-tooltip #cardDescription 
          (mouseenter)="showToolTip(cardDescription)"
          title="{{isMultiLineDescription ? (description | formatMessageRule:true:description:model:specFields) : ''}}">
          {{description | formatMessageRule:true:description:model:specFields}}</p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isWebAppLink" class="lm-card-view" (click)="onClickEvent($event)" [style.cursor]="'pointer'">
  <div class="lm-card-image">
    <img *ngIf="hasImage" src="{{imageUrl}}"/>
  </div>
  <div class="lm-card-content">
    <div class="lm-card-title" soho-tooltip title="{{title | formatMessageRule:true:title:model:specFields}}">
      <a soho-hyperlink
         [attr.tabindex]="isInAccessibilityMode ? 0 : null"
         (keydown.enter)="onClickEvent($event)"
         (fieldEvent)="onFieldEvent($event)">
        <span>{{title | formatMessageRule:true:title:model:specFields}}</span>
      </a>
    </div>
    <div class="lm-card-flex">
      <div class="lm-column">
        <p soho-tooltip #cardDescription 
         (mouseenter)="showToolTip(cardDescription)"
         title="{{isMultiLineDescription ? (description | formatMessageRule:true:description:model:specFields) : ''}}">
         {{description | formatMessageRule:true:description:model:specFields}}</p>
      </div>
    </div>

    <ng-template [ngIf]="isWebAppLink">
      <button
          soho-menu-button
          hideMenuArrow=true
          class="btn-actions"
          icon="more"
          attachToBody="'true'"
          removeOnDestroy="'true'"
          [style.visibility]="this.lmContextService.inMingleWidget() ? 'hidden' : 'visible'"
      >
        <span class="audible">{{'More' | translate}} - {{title | formatMessageRule:true:title:model:specFields}}</span>
      </button>
      <div class="popupmenu-wrapper bottom" role="application" aria-hidden="true">
        <ul class="popupmenu is-selectable"  id="{{webAppName}}">
          <li class="btn">
            <a (keydown.space)="onPreferredMenuEvent($event)" (click)="onPreferredMenuEvent($event)" attr.aria-label="{{'SetPreferred' | translate}}">{{setPreferred}}</a>
          </li>
        </ul>
      </div>
    </ng-template>
  </div>
  <span *ngIf="isPreferred"><img class="preferred" src="./lib/landmark/images/defaultPage.png" title="Preferred" alt=""></span>
</div>
